import { Sections } from '../Sections';

const SectionsMock: Sections = [
  {
    name: 'motor',
    displayText: 'Cars & Motor',
    isVisible: true,
    sections: [
      {
        name: 'motor',
        displayText: 'See all in Cars & Motor',
        isVisible: false,
        sections: null,
      },
      {
        name: 'boatextras',
        displayText: 'Boat Extras',
        isVisible: true,
        sections: null,
      },
      {
        name: 'boats',
        displayText: 'Boats & Jet Skis',
        isVisible: true,
        sections: null,
      },
      {
        name: 'damagedcars',
        displayText: 'Breaking & Repairables',
        isVisible: true,
        sections: null,
      },
      {
        name: 'campers',
        displayText: 'Campers',
        isVisible: true,
        sections: null,
      },
      {
        name: 'carextras',
        displayText: 'Car Extras',
        isVisible: true,
        sections: [
          {
            name: 'carextras',
            displayText: 'See all in Car Extras',
            isVisible: false,
            sections: null,
          },
          {
            name: 'alloyswheels',
            displayText: 'Alloys & Wheels',
            isVisible: true,
            sections: null,
          },
          {
            name: 'caraccessories',
            displayText: 'Car Accessories',
            isVisible: true,
            sections: null,
          },
          {
            name: 'tyres',
            displayText: 'Tyres',
            isVisible: true,
            sections: null,
          },
        ],
      },
      {
        name: 'carparts',
        displayText: 'Car Parts',
        isVisible: true,
        sections: null,
      },
      {
        name: 'caravans',
        displayText: 'Caravans',
        isVisible: true,
        sections: null,
      },
      {
        name: 'cars',
        displayText: 'Cars',
        isVisible: true,
        sections: null,
      },
      {
        name: 'coaches',
        displayText: 'Coaches & Buses',
        isVisible: true,
        sections: null,
      },
      {
        name: 'commercials',
        displayText: 'Commercials',
        isVisible: true,
        sections: null,
      },
      {
        name: 'modifiedcars',
        displayText: 'Modified Cars',
        isVisible: true,
        sections: null,
      },
      {
        name: 'motorbikeextras',
        displayText: 'Motorbike Extras',
        isVisible: true,
        sections: null,
      },
      {
        name: 'motorbikes',
        displayText: 'Motorbikes',
        isVisible: true,
        sections: null,
      },
      {
        name: 'othermotor',
        displayText: 'Other Motor',
        isVisible: true,
        sections: null,
      },
      {
        name: 'plantmachinery',
        displayText: 'Plant Machinery',
        isVisible: true,
        sections: null,
      },
      {
        name: 'quads',
        displayText: 'Quads',
        isVisible: true,
        sections: null,
      },
      {
        name: 'rallycars',
        displayText: 'Rally Cars',
        isVisible: true,
        sections: null,
      },
      {
        name: 'scooters',
        displayText: 'Scooters',
        isVisible: true,
        sections: null,
      },
      {
        name: 'trailers',
        displayText: 'Trailers',
        isVisible: true,
        sections: null,
      },
      {
        name: 'trucks',
        displayText: 'Trucks',
        isVisible: true,
        sections: null,
      },
      {
        name: 'vintagebikes',
        displayText: 'Vintage Bikes',
        isVisible: true,
        sections: null,
      },
      {
        name: 'vintagecars',
        displayText: 'Vintage Cars',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'farming',
    displayText: 'Farming',
    isVisible: true,
    sections: [
      {
        name: 'farming',
        displayText: 'See all in Farming',
        isVisible: false,
        sections: null,
      },
      {
        name: 'machinery',
        displayText: 'Farm Machinery',
        isVisible: true,
        sections: [
          {
            name: 'machinery',
            displayText: 'See all in Farm Machinery',
            isVisible: false,
            sections: null,
          },
          {
            name: 'agitators',
            displayText: 'Agitators',
            isVisible: true,
            sections: null,
          },
          {
            name: 'balers',
            displayText: 'Balers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'cattletrailers',
            displayText: 'Cattle Trailers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'combineharvesters',
            displayText: 'Combine Harvesters',
            isVisible: true,
            sections: null,
          },
          {
            name: 'fertiliserspreaders',
            displayText: 'Fertiliser Spreaders',
            isVisible: true,
            sections: null,
          },
          {
            name: 'harrows',
            displayText: 'Harrows',
            isVisible: true,
            sections: null,
          },
          {
            name: 'haybobs',
            displayText: 'Hay & Forage',
            isVisible: true,
            sections: null,
          },
          {
            name: 'hedgecutters',
            displayText: 'Hedge Cutters',
            isVisible: true,
            sections: null,
          },
          {
            name: 'manurespreaders',
            displayText: 'Manure Spreaders',
            isVisible: true,
            sections: null,
          },
          {
            name: 'milkingparlours',
            displayText: 'Milking Parlours',
            isVisible: true,
            sections: null,
          },
          {
            name: 'mowers',
            displayText: 'Mowers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'otherfarmmachinery',
            displayText: 'Other Farm Machinery',
            isVisible: true,
            sections: null,
          },
          {
            name: 'ploughs',
            displayText: 'Ploughs',
            isVisible: true,
            sections: null,
          },
          {
            name: 'rollers',
            displayText: 'Rollers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'rotovators',
            displayText: 'Rotovators',
            isVisible: true,
            sections: null,
          },
          {
            name: 'silagegrabs',
            displayText: 'Silage Grabs',
            isVisible: true,
            sections: null,
          },
          {
            name: 'silageharvesters',
            displayText: 'Silage Harvesters',
            isVisible: true,
            sections: null,
          },
          {
            name: 'silagetrailers',
            displayText: 'Silage Trailers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'silagewrappers',
            displayText: 'Silage Wrappers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'tractorparts',
            displayText: 'Spare Parts',
            isVisible: true,
            sections: null,
          },
          {
            name: 'toppers',
            displayText: 'Toppers',
            isVisible: true,
            sections: null,
          },
          {
            name: 'tractortyres',
            displayText: 'Wheels & Tyres',
            isVisible: true,
            sections: null,
          },
        ],
      },
      {
        name: 'farmservices',
        displayText: 'Farm Services',
        isVisible: true,
        sections: null,
      },
      {
        name: 'farmsheds',
        displayText: 'Farm Sheds',
        isVisible: true,
        sections: null,
      },
      {
        name: 'farmersnoticeboard',
        displayText: 'Farmers Noticeboard',
        isVisible: true,
        sections: null,
      },
      {
        name: 'feedingequipment',
        displayText: 'Feeding Equipment',
        isVisible: true,
        sections: null,
      },
      {
        name: 'fencingequipment',
        displayText: 'Fencing Equipment',
        isVisible: true,
        sections: null,
      },
      {
        name: 'fertilisers',
        displayText: 'Fertilisers',
        isVisible: true,
        sections: null,
      },
      {
        name: 'livestock',
        displayText: 'Livestock',
        isVisible: true,
        sections: [
          {
            name: 'livestock',
            displayText: 'See all in Livestock',
            isVisible: false,
            sections: null,
          },
          {
            name: 'beefcattle',
            displayText: 'Beef Cattle',
            isVisible: true,
            sections: null,
          },
          {
            name: 'dairycattle',
            displayText: 'Dairy Cattle',
            isVisible: true,
            sections: null,
          },
          {
            name: 'sheep',
            displayText: 'Sheep',
            isVisible: true,
            sections: null,
          },
        ],
      },
      {
        name: 'tractors',
        displayText: 'Tractors',
        isVisible: true,
        sections: null,
      },
      {
        name: 'vintagemachinery',
        displayText: 'Vintage Machinery',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'animals',
    displayText: 'Animals',
    isVisible: true,
    sections: [
      {
        name: 'animals',
        displayText: 'See all in Animals',
        isVisible: false,
        sections: null,
      },
      {
        name: 'equine',
        displayText: 'Equine',
        isVisible: true,
        sections: [
          {
            name: 'equine',
            displayText: 'See all in Equine',
            isVisible: false,
            sections: null,
          },
          {
            name: 'horseboxes',
            displayText: 'Horse Transport',
            isVisible: true,
            sections: null,
          },
        ],
      },
    ],
  },
  {
    name: 'babyandkids',
    displayText: 'Baby & Kids',
    isVisible: true,
    sections: [
      {
        name: 'babyandkids',
        displayText: 'See all in Baby & Kids',
        isVisible: false,
        sections: null,
      },
      {
        name: 'toys',
        displayText: 'Toys',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'business',
    displayText: 'Business',
    isVisible: true,
    sections: [
      {
        name: 'business',
        displayText: 'See all in Business',
        isVisible: false,
        sections: null,
      },
      {
        name: 'cateringfittings',
        displayText: 'Catering Fittings',
        isVisible: true,
        sections: null,
      },
      {
        name: 'catering',
        displayText: 'Mobile Catering',
        isVisible: true,
        sections: null,
      },
      {
        name: 'shopfittings',
        displayText: 'Shop Fittings',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'homeelectronics',
    displayText: 'Electronics',
    isVisible: true,
    sections: [
      {
        name: 'homeelectronics',
        displayText: 'See all in Electronics',
        isVisible: false,
        sections: null,
      },
      {
        name: 'tv',
        displayText: 'TV',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'household',
    displayText: 'House & DIY',
    isVisible: true,
    sections: [
      {
        name: 'household',
        displayText: 'See all in House & DIY',
        isVisible: false,
        sections: null,
      },
      {
        name: 'gardening',
        displayText: 'Garden & Landscaping',
        isVisible: true,
        sections: [
          {
            name: 'gardening',
            displayText: 'See all in Garden & Landscaping',
            isVisible: false,
            sections: null,
          },
          {
            name: 'gardenequipment',
            displayText: 'Garden Equipment',
            isVisible: true,
            sections: null,
          },
          {
            name: 'gardenfurniture',
            displayText: 'Garden Furniture & Decking',
            isVisible: true,
            sections: null,
          },
        ],
      },
      {
        name: 'homeimprovements',
        displayText: 'Home Improvements & DIY',
        isVisible: true,
        sections: [
          {
            name: 'homeimprovements',
            displayText: 'See all in Home Improvements & DIY',
            isVisible: false,
            sections: null,
          },
          {
            name: 'tools',
            displayText: 'Machinery & Tools',
            isVisible: true,
            sections: null,
          },
        ],
      },
    ],
  },
  {
    name: 'property',
    displayText: 'Property',
    isVisible: true,
    sections: [
      {
        name: 'property',
        displayText: 'See all in Property',
        isVisible: false,
        sections: null,
      },
      {
        name: 'mobilehomes',
        displayText: 'Mobile Homes',
        isVisible: true,
        sections: null,
      },
    ],
  },
  {
    name: 'sport',
    displayText: 'Sport & Hobbies',
    isVisible: true,
    sections: [
      {
        name: 'sport',
        displayText: 'See all in Sport & Hobbies',
        isVisible: false,
        sections: null,
      },
      {
        name: 'gymequipment',
        displayText: 'Gym Equipment',
        isVisible: true,
        sections: null,
      },
    ],
  },
];
export default SectionsMock;
